(function() {
    'use strict';
    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ASTBOfficeController', OfficeController);
    window.localStorage.removeItem("DataTables_nasracofficebar_/");
    OfficeController.$inject = ['$scope', '$state', 'Office', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder' , 'GUIUtils', '$filter', '$compile', 'Principal', 'AuthServerProvider'];

    function OfficeController ($scope, $state, Office, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, Principal, AuthServerProvider ) {
        var vm = this;
        vm.offices = [];

        vm.office = {
        		createOfficeRoles: "Administrators,Billing Administrator"
        	};


        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/offices/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {

                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
                    //  data.columns[1].data = "emailAddress";
                    data.columns.shift();
                    //data.columns.splice(3);
                    data.order[0].column = data.order[0].column - 1;
                    data.columns[2].data = "mso.msoName";
                   // data.column[2].data="office.mso."
                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                }
            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")

            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            })
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withButtons([
                {
                    //extend: 'csvHtml5', // removing action column TODO : remove action header
                    text:'Export',
                    key:'1',

                    /*exportOptions: {
                     columns: [1, 2, 3]
                     }*/
                    action: function (e, dt, node, config) {
                        Office.download().$promise
                            .then(function (data) {
//                    	console.log(data);
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_ Office.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    }
                }
            ])
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);


          vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('officeName').withTitle('Office Name'),

              DTColumnBuilder.newColumn('officeAddress').withTitle('Office Address'),
            DTColumnBuilder.newColumn('msoMsoName').withTitle('MSO Name')

           ];

        if (Principal.hasAnyAuthority(['Billing User'])){
        	vm.dtColumns[0].visible = false;
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();
